<template>
  <b-modal
    v-model="isShow"
    :title="modalTitle"
    size="lg"
    centered
    scrollable
    no-close-on-backdrop
    @hide="onReset"
    id="editInviteCode"
  >
    <div class="body-content" id="eidtcode">
      <b-row class="line">
        <b-col>
          <label>
            <!-- 原邀请码 -->
             {{$t('editInvitationCode.originalCode')}}
          </label>
          <b-input-group>
            <b-form-input
              class="append-input"
              v-model="originalCode"
              disabled
            >
            </b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="line">
        <b-col>
          <label>
            <!-- 新邀请码 -->
            {{$t('editInvitationCode.newCode')}}
          </label>
          <b-input-group>
            <b-form-input
              class="append-input"
              v-model.trim="$v.form.inviteCode.$model"
              :placeholder="$t('editInvitationCode.placeholder')"
              maxLength="9"
              :state="chkState('inviteCode')"
            >
            </b-form-input>
          </b-input-group>
          <div class="text-danger" v-if="!$v.form.inviteCode.required || !$v.form.inviteCode.proofValue">
            <!-- 请输入6-9个大写字母或数字 -->
            {{$t('editInvitationCode.errotText')}}
          </div>
        </b-col>
      </b-row>
      <b-row class="textWarning-box">
        <b-col>
          <p class="textWarning">
            <!-- 注：邀请码修改成功后，邀请链接会被同步修改，旧的邀请码和邀请链接将会失效。 -->
            {{$t('editInvitationCode.note')}}
          </p>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer>
      <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
        $t("common.cancel")
      }}</b-button>
      <b-button class="coustom-btn" variant="primary" @click="save">{{
        $t("common.save")
      }}</b-button>
    </template>
  </b-modal>
</template>

    <script>
import { requiredIf } from "vuelidate/lib/validators";
export default {
  name: "actDataModal",
  props: ["modalShow", "originalCode"],
  data() {
    return {
      isShow: false,
      oldCode: '',
      form: {
        inviteCode: null,
      },
      addSave: false,
      saveFlag: true, //保存防二次点击
    };
  },
  watch: {
    modalShow(v) {
      this.isShow = v;
    },
  },
  computed: {
    modalTitle () {
      return this.$t('editInvitationCode.customCode');  // '自定义邀请码'
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
  },
  created() {
    this.isShow = this.modalShow;
  },
  validations: {
    form: {
      inviteCode: {
        required: requiredIf(function () {
          return this.addSave;
        }),
        proofValue: function (v) {
          if (v) {
            const regex = /^[A-Z0-9]{6,9}$/;
            return regex.test(v);
          }
          return true;
        },
      },
    },
  },
  methods: {
   
    // 保存
    save() {
      this.addSave = true;
      let flag = true;
      if (!this.validate()) {
        flag = false;
      }
      if(this.form.inviteCode && this.originalCode === this.form.inviteCode) {
        this.$bus.$emit("alert", { type: "error", message: this.$t('editInvitationCode.errotText2') });
        flag = false;
      }
      if (!this.saveFlag || !flag) return;
      this.saveFlag = false;
      this.$http({
        url: this.$store.state.url.agent.updateInviteCode,
        params: {
          inviteCode: this.form.inviteCode,
        },
      }).then((data) => {
        this.saveFlag = true;
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", { type: "success", message: this.$t("publicManage.lanset.saveSuccess") });
          this.$parent.getData();
          this.onReset();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    onReset() {
      this.addSave = false;
      this.form.inviteCode = null;
      this.$emit("changeModalShow", false);
      this.$v.form.$reset();
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>

<style lang="scss">
#editInviteCode {
  .text-danger {
    margin-top: 4px;
  }
  .modal-dialog #eidtcode .textWarning-box {
    margin-bottom: 0 !important;
  }
  .textWarning {
    color: #FAAD14;
    font-size: 14px;
    line-height: 22px;
    margin: 0;
  }
}
  
</style>
